<template>
  <div>
    <div class="flex flex-wrap -m-1.5 xl:-m-2 2xl:-m-2.5">
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full">
        <StatisticCard
          :loading="loading"
          :title="$t('total_#_reservoirs_structures_count')"
          :count="data['total_#_reservoirs'] || 0"
          :img="require('@/assets/img/icons/all-hydro.svg')"
          class="bg-indigo-50 text-indigo-800 cursor-pointer h-full"
          @click="$router.push('/reservoir')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('all_reservoir_count')"
          :count="data.reservoir || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/reservoir')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_reservoir')"
          :count="data.sustainable_reservoir || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/reservoir')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_reservoir')"
          :count="data.not_sustainable_reservoir || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/reservoir')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('all_hydro_units')"
          :count="data.hydro_units || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydrounits')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_hydro_units')"
          :count="data.sustainable_hydro_units || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydrounits')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_hydro_units')"
          :count="data.not_sustainable_hydro_units || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydrounits')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('all_pumping_station_count')"
          :count="data.pumping_station || 0"
          :img="require('@/assets/img/icons/pumping_station.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/pumpingstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_pumping_station')"
          :count="data.sustainable_pumping_station || 0"
          :img="require('@/assets/img/icons/pumping_station.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/pumpingstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_pumping_station')"
          :count="data.not_sustainable_pumping_station || 0"
          :img="require('@/assets/img/icons/pumping_station.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/pumpingstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('all_hydroelectric_power_stations_count')"
          :count="data.hydroelectric_power_stations || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydroelectricpowerstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_hydroelectric_power_stations')"
          :count="data.sustainable_hydroelectric_power_stations || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydroelectricpowerstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_hydroelectric_power_stations')"
          :count="data.not_sustainable_hydroelectric_power_stations || 0"
          :img="require('@/assets/img/icons/eservoir.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/hydroelectricpowerstations')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('all_canals_count')"
          :count="data.canals || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/canals')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_canals')"
          :count="data.sustainable_canals || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/canals')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_canals')"
          :count="data.not_sustainable_canals || 0"
          :img="require('@/assets/img/icons/hydro_units.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/reservoir/canals')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatisticCard from "./Card.vue";

export default {
  name: "HydroStatistic",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StatisticCard,
  },
};
</script>

<style lang="scss" scoped></style>
